import {
  chromeViewerRouteMatches,
  tokenizedOwnershipMatches,
} from '../utils/chromeViewerRequestOwnership';

export const initialCurrentRecordRequest = {
  loading: false,
  error: false,
  errorMessage: null,
  errorCode: null,
  completed: false,
  attemptToken: null,
  routeOwnerId: null,
  routeGeneration: null,
  mode: 'legacy',
  settled: false,
  selectionSaveAttemptToken: null,
  selectionSaveSettled: false,
};

export const currentRecordRequestForBegin = (action) => {
  const ownership = action.meta?.requestOwnership;
  if (!ownership) {
    return {
      ...initialCurrentRecordRequest,
      loading: true,
    };
  }

  return {
    ...initialCurrentRecordRequest,
    loading: true,
    attemptToken: ownership.attemptToken,
    routeOwnerId: ownership.routeOwnerId,
    routeGeneration: ownership.routeGeneration,
    mode: 'tokenized',
  };
};

export const terminalMatchesCurrentRecordRequest = (request, action) => {
  const ownership = action.meta?.requestOwnership;
  if (!ownership) return request?.mode !== 'tokenized';

  return tokenizedOwnershipMatches(request, ownership) && !request.settled;
};

export const settledCurrentRecordRequest = (request, action, updates) => {
  const baseRequest = action.meta?.requestOwnership
    ? request
    : initialCurrentRecordRequest;

  return {
    ...baseRequest,
    loading: false,
    settled: true,
    ...updates,
  };
};

export const currentRecordRequestForSelectionSaveBegin = (request, action) => {
  const ownership = action.meta?.requestOwnership;
  if (ownership?.kind !== 'selection-save'
    || !tokenizedOwnershipMatches(request, ownership)) {
    return request;
  }

  return {
    ...request,
    selectionSaveAttemptToken: ownership.selectionSaveAttemptToken,
    selectionSaveSettled: false,
  };
};

export const selectionSaveMatchesCurrentRecordRequest = (request, action) => {
  const ownership = action.meta?.requestOwnership;
  if (!ownership) return request?.mode !== 'tokenized';

  return ownership.kind === 'selection-save'
    && action.meta.selectionSaveGatePassed === true
    && tokenizedOwnershipMatches(request, ownership)
    && request.selectionSaveAttemptToken === ownership.selectionSaveAttemptToken
    && !request.selectionSaveSettled
    && chromeViewerRouteMatches(action.meta.routePathname, ownership.routeOwnerId);
};

export const settleCurrentRecordSelectionSave = (request) => ({
  ...request,
  selectionSaveSettled: true,
});
